// extracted by mini-css-extract-plugin
module.exports = {"layout":"PublicLayout_layout__1zDfl"};